export type ResolveOnboardingFormSaveParams = {
  isQuickWinSingleton: boolean;
  onboardingFormRef?: { uuid?: string };
  queryOnboardingForm?: { uuid?: string };
  loadingForm: boolean;
};

export const resolveOnboardingFormSave = (
  params: ResolveOnboardingFormSaveParams
): { formUuid?: string; canSave: boolean; shouldNotify: boolean } => {
  const { isQuickWinSingleton, onboardingFormRef, queryOnboardingForm, loadingForm } = params;

  // AC-5: Non-QUICK_WIN forms preserve previous behavior
  if (!isQuickWinSingleton) {
    return {
      formUuid: queryOnboardingForm?.uuid,
      canSave: true,
      shouldNotify: false,
    };
  }

  // AC-1: QUICK_WIN singleton without prior reference → allow initial creation
  if (!onboardingFormRef) {
    return {
      formUuid: undefined,
      canSave: true,
      shouldNotify: false,
    };
  }

  // AC-2: UUID from queried detail (priority) or canonical reference (fallback)
  if (queryOnboardingForm?.uuid) {
    return {
      formUuid: queryOnboardingForm.uuid,
      canSave: true,
      shouldNotify: false,
    };
  }

  if (onboardingFormRef.uuid) {
    return {
      formUuid: onboardingFormRef.uuid,
      canSave: true,
      shouldNotify: false,
    };
  }

  // Reference exists but no UUID resolvable
  // AC-3: loading finished → block and notify
  if (!loadingForm) {
    return {
      formUuid: undefined,
      canSave: false,
      shouldNotify: true,
    };
  }

  // Still loading → block without notifying
  return {
    formUuid: undefined,
    canSave: false,
    shouldNotify: false,
  };
};